import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@mantine/core';

import { menuListOW, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import AccountResetEmail from "../../pagesSub/accountUser/AccountResetEmail";
import AccountResetUsernamePassword from "../../pagesSub/accountUser/AccountResetUsernamePassword";

const AccountOW = () => {

    const { subMenu, tab } = useParams();
    const menu = menuListOW.account.slug;
    const roleUser = role.owner;
    const slugLink = roleUser.subLevel.owner.slugLink;

    return (
        <LayoutAppShell
            stateMenuList={menuListOW}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListOW.account.subMenu.one.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListOW.account.subMenu.one.tabs.one.flag}>
                                {menuListOW.account.subMenu.one.tabs.one.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListOW.account.subMenu.one.tabs.two.flag}>
                                {menuListOW.account.subMenu.one.tabs.two.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListOW.account.subMenu.one.tabs.one.flag}>
                            <AccountResetEmail />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListOW.account.subMenu.one.tabs.two.flag}>
                            <AccountResetUsernamePassword />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default AccountOW;